import React from 'react';
import ReactCommonmark from 'react-commonmark';
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import TextArea from 'v2/form/TextArea/TextArea';
import {
  ProposalEntity,
  ProviderProposalResponseFields,
  SearchEntity,
} from 'v2/models';
import { ProviderProposalTokenResponseFields } from './ProposalResponse';
import { get_data_buyer_description } from 'v2/utils/proposalUtils';
import CheckSellerResponse from '../DataRequests/CheckResponse/CheckSellerResponse';

interface StepTwoProps {
  proposal: ProposalEntity;
  isCheckSellerResponseEnabled: boolean;
  control: Control<ProviderProposalTokenResponseFields>;
  register: UseFormRegister<ProviderProposalTokenResponseFields>;
  errors: FieldErrors<ProviderProposalTokenResponseFields>;
}

const StepTwo = ({
  proposal,
  register,
  errors,
  isCheckSellerResponseEnabled,
  control,
}: StepTwoProps) => {
  const search = proposal.search as SearchEntity;
  const errMsg = errors.response?.message;
  const convertedControl = control as Control<
    ProviderProposalResponseFields | ProviderProposalTokenResponseFields
  >;
  return (
    <div className="p-5 border-bottom">
      <label className="text-primary-dark">{search.name}</label>
      <ReactCommonmark
        className="text-light4"
        source={search.description}
        softBreak="br"
      />

      <div className="pt-4">
        <label className="text-primary-dark">Client Description</label>
        <ReactCommonmark
          className="text-light4"
          source={get_data_buyer_description(proposal) || ''}
          softBreak="br"
        />
      </div>

      <TextArea
        className={errors.response?.message ? 'field-error-box' : ''}
        register={register('response', { required: true })}
        rows={5}
        autoComplete="off"
        required={true}
        placeholder="How does your data product address the buyer's need?"
      />
      {errMsg ? <p className="text-danger">{errMsg}</p> : null}
      {isCheckSellerResponseEnabled && (
        <CheckSellerResponse
          control={convertedControl}
          errors={errors}
          searchDescription={search.description}
        />
      )}
      <p className="text-light2">
        <span>Avoid vague answers such as “Yes we have the data”</span>
        <br />
        <span>
          Avoid sharing contact information until after your offer has been
          accepted
        </span>
      </p>
    </div>
  );
};

export default StepTwo;
